import { render, staticRenderFns } from "./secondary-logo.vue?vue&type=template&id=4cbb01d7&"
import script from "./secondary-logo.vue?vue&type=script&lang=js&"
export * from "./secondary-logo.vue?vue&type=script&lang=js&"
import style0 from "./secondary-logo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports